"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValuesDiff = exports.jsonToValue = exports.valueToJson = exports.valueToString = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var valueToString = function valueToString(value) {
  if (typeof value === 'string' || value instanceof String) {
    return value.toString();
  }

  if (typeof value === 'number') {
    return "".concat(value);
  }

  return '';
};

exports.valueToString = valueToString;

var valueToJson = function valueToJson(value) {
  return JSON.stringify({
    v: value
  });
};

exports.valueToJson = valueToJson;

var jsonToValue = function jsonToValue(json) {
  var _JSON$parse = JSON.parse(json),
      v = _JSON$parse.v;

  return v;
};

exports.jsonToValue = jsonToValue;

var getValuesDiff = function getValuesDiff(prev, current, maxLevel) {
  var currentLevel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return _lodash["default"].transform(current, function (result, value, key) {
    if (prev[key] === undefined) {
      result[key] = value;
    } else if (!_lodash["default"].isEqual(value, prev[key])) {
      result[key] = (value !== null && _typeof(value) === 'object' || Array.isArray(value)) && (!maxLevel || maxLevel && currentLevel < maxLevel) ? getValuesDiff(prev[key], value, maxLevel, currentLevel + 1) : value;
    }
  });
};

exports.getValuesDiff = getValuesDiff;